<svg height="100%" viewBox="0 0 3000 2500" width="100%">

  @for (piece of pieces; track piece) {
    <ng-container>
      <ng-container>
        @switch (piece.type) {
          @case ('Tambour') {
            <circle [attr.r]="piece.width/2"
              [attr.cx]="piece.x | calcSvgXPosition:false:piece:true"
              [attr.cy]="piece.y | calcSvgYPosition:false:piece:true"
              style="stroke-width:10;stroke:rgb(0,0,0)"
              [attr.title]="piece | json"
              >
            </circle>
          }
          @default {
            <ng-container>
              <rect [ngClass]="{tambour:piece.type==='Tambour'}"
                [attr.height]="piece.flip?piece.width:piece.height"
                [attr.width]="piece.flip?piece.height:piece.width"
                [attr.x]="piece.x | calcSvgXPosition:piece.flip:piece"
                [attr.y]="piece.y | calcSvgYPosition:piece.flip:piece"
                style="stroke-width:10;stroke:rgb(0,0,0)" />
              </ng-container>
            }
          }
        </ng-container>
      </ng-container>
    }


  </svg>
  <div class="price">{{price}}</div>
